'use client';
import styled, { css } from 'styled-components';

/**
 * Each cell takes its column share of the row so nested CtaButton
 * alignment can pack the button within the cell.
 */
const columnSizing = (columns, gapSpacing) => css`
  flex: 0 1 auto;
  width: calc((100% - (${columns} - 1) * ${gapSpacing}) / ${columns});
  max-width: 100%;
`;

const stretchFullWidth = css`
  flex: 1 1 100%;
  width: 100%;
  max-width: 100%;

  & > * {
    width: 100%;
    max-width: 100%;
  }
`;

export const StyledCTAGroupComponent = styled.div`
  margin: ${props => props.theme.spacing(4, 0)};
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  gap: ${props => props.theme.spacing(props.$gap ? props.$gap : 4)};
`;

export const CTAButtonWrapper = styled.div`
  ${props => props.theme.getFocusOutline()};
  box-sizing: border-box;
  min-width: 0;

  & > * {
    width: 100%;
    max-width: 100%;
  }

  ${props =>
    !props.$fullWidthMobile &&
    css`
      min-width: min(100%, ${props.$minWidth || 240}px);
    `}
  ${props =>
    columnSizing(
      props.$buttonsPerRowMobile || 1,
      props.theme.spacing(props.$gap ? props.$gap : 4),
    )}

  ${props => props.$fullWidthMobile && stretchFullWidth}

  @media ${props => props.theme.tablet} {
    min-width: 0;
    ${props =>
      !props.$fullWidthDesktop &&
      css`
        min-width: min(100%, ${props.$minWidth || 240}px);
      `}
    ${props =>
      columnSizing(
        props.$buttonsPerRow || 2,
        props.theme.spacing(props.$gap ? props.$gap : 4),
      )}

    ${props => props.$fullWidthDesktop && stretchFullWidth}
  }
`;
